{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/terms-query",
	"title": "Terms Query",
	"category": "theme",
	"description": "An advanced block that allows displaying taxonomy terms based on different query parameters and visual configurations.",
	"keywords": [ "terms", "taxonomy", "categories", "tags", "list" ],
	"textdomain": "default",
	"attributes": {
		"termQuery": {
			"type": "object",
			"default": {
				"perPage": 10,
				"taxonomy": "category",
				"order": "asc",
				"orderBy": "name",
				"include": [],
				"hideEmpty": true,
				"showNested": false,
				"inherit": false
			}
		},
		"tagName": {
			"type": "string",
			"default": "div"
		}
	},
	"usesContext": [ "templateSlug" ],
	"providesContext": {
		"termQuery": "termQuery"
	},
	"supports": {
		"anchor": true,
		"align": [ "wide", "full" ],
		"html": false,
		"layout": true,
		"spacing": {
			"padding": true,
			"margin": true,
			"blockGap": true
		},
		"interactivity": true
	}
}
